import type { CSSProperties } from 'react';
import type { ActivationFunnel } from '../../services/analytics';
import { buildFunnelSegments, funnelPolygon } from './funnel';
import { formatInt, formatPct } from './format';
import styles from './FunnelChart.module.css';

interface FunnelChartProps {
    funil: ActivationFunnel;
}

/** Funil em faixas: cada etapa abre no seu percentual e fecha no da etapa seguinte. */
export function FunnelChart({ funil }: FunnelChartProps) {
    const segments = buildFunnelSegments(funil.stages);
    return (
        <ol className={styles.funnel}>
            {segments.map((s, i) => (
                <li key={s.stage.id} className={styles.row}>
                    <span className={styles.label}>{s.label}</span>
                    <span className={styles.shape} aria-hidden="true">
                        <span
                            className={styles.fill}
                            style={
                                {
                                    clipPath: funnelPolygon(s.topPct, s.bottomPct),
                                    backgroundColor: `var(--funnel-${i + 1})`,
                                } as CSSProperties
                            }
                        />
                    </span>
                    <span className={styles.value}>
                        <strong className={styles.count}>{formatInt(s.stage.count)}</strong>
                        <span className={styles.pct}>&middot; {formatPct(s.stage.pct)}</span>
                    </span>
                </li>
            ))}
        </ol>
    );
}
